import { render, staticRenderFns } from "./PageReviewedEvidence.vue?vue&type=template&id=1ae68661&"
import script from "./PageReviewedEvidence.vue?vue&type=script&lang=js&"
export * from "./PageReviewedEvidence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports